import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { setStoredPortfolioAccountId } from './portfolioAccountStorage';

const PortfolioLegacyRedirect = () => {
  const { accountId } = useParams<{ accountId: string }>();

  useEffect(() => {
    if (accountId) {
      setStoredPortfolioAccountId(accountId);
    }
  }, [accountId]);

  return <Navigate to="/portfolio" replace />;
};

export default PortfolioLegacyRedirect;
